<script setup lang="ts">
import { usePageContext } from 'vike-vue/usePageContext'

const { footer } = usePageContext()
</script>

<template>
  <organisms-ui-footer
    id="main-footer"
    v-bind="footer"
    class="Footer"
  />
</template>
